export const ErrorStatus = {
    650: "В классе нет учеников",
    680: "Превышено кол-во использований промокода",
    681: "Промокод уже использован",
    682: "Применилась скидка 100%. Подписка выдана.",
    683: "Промокод не найден",
    684: "Промокод не подходит для данной подписки"
}
